// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"42e4b02c","699":"42e4b02c","715":"42e4b02c","785":"42e4b02c","826":"42e4b02c"}[chunkId] + ".chunk.css";
};